import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  FormControlLabel,
  Checkbox,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
  Typography,
  CircularProgress,
} from "@mui/material";
import {
  fonts,
  headingFonts,
  primaryButtonStyles,
  secondaryButtonStyles,
  selectStyles,
  textFieldStyles,
} from "../../../../Styles/Styles";

export default function EditUserModal({
  isSubmitting,
  editFormData,
  handleEditFormChange,
  handleSaveEdit,
  open,
  onClose,
}) {
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle sx={{ ...headingFonts }}>Edit User</DialogTitle>
      <DialogContent>
        <TextField
          margin="dense"
          name="firstName"
          label="First Name"
          type="text"
          fullWidth
          variant="outlined"
          value={editFormData.firstName}
          onChange={handleEditFormChange}
          sx={{ ...textFieldStyles }}
        />
        <TextField
          margin="dense"
          name="lastName"
          label="Last Name"
          type="text"
          fullWidth
          variant="outlined"
          value={editFormData.lastName}
          onChange={handleEditFormChange}
          sx={{ ...textFieldStyles }}
        />
        <TextField
          margin="dense"
          name="username"
          label="Username"
          type="text"
          fullWidth
          variant="outlined"
          value={editFormData.username}
          onChange={handleEditFormChange}
          sx={{ ...textFieldStyles }}
        />
        <TextField
          margin="dense"
          name="email"
          label="Email"
          type="email"
          fullWidth
          variant="outlined"
          value={editFormData.email}
          onChange={handleEditFormChange}
          sx={{ ...textFieldStyles }}
        />
        <FormControl fullWidth variant="outlined" margin="dense">
          <InputLabel sx={{ ...fonts }}>Country Code</InputLabel>
          <Select
            name="countryCode"
            value={editFormData.countryCode}
            onChange={handleEditFormChange}
            label="Country Code"
            sx={{ ...selectStyles }}
          >
            <MenuItem value="+1345" sx={{ ...fonts }}>
              +1345
            </MenuItem>
          </Select>
        </FormControl>
        <TextField
          margin="dense"
          name="phoneNumber"
          label="Phone Number"
          type="text"
          fullWidth
          variant="outlined"
          value={editFormData.phoneNumber}
          onChange={(e) => {
            const value = e.target.value.replace(/\D/g, "").slice(0, 7); // Remove non-numeric characters and limit to 7 characters
            handleEditFormChange({ target: { name: e.target.name, value } });
          }}
          inputProps={{ maxLength: 7 }} // Restrict input length to 7
          sx={{ ...textFieldStyles }}
        />

        <TextField
          margin="dense"
          name="organization"
          label="Organization"
          type="text"
          fullWidth
          variant="outlined"
          value={editFormData.organization}
          onChange={handleEditFormChange}
          sx={{ ...textFieldStyles }}
        />
        <FormControlLabel
          control={
            <Checkbox
              name="subscribeNewsletter"
              checked={editFormData.subscribeNewsletter}
              onChange={handleEditFormChange}
              sx={{
                "&.Mui-checked": {
                  color: "var(--primary-color)", // Filled color when checked
                },
              }}
            />
          }
          label={
            <Typography sx={{ ...fonts }}>Subscribe to Newsletter</Typography>
          }
        />
        <FormControlLabel
          control={
            <Checkbox
              name="isVerified"
              checked={editFormData.isVerified}
              onChange={handleEditFormChange}
              sx={{
                "&.Mui-checked": {
                  color: "var(--primary-color)", // Filled color when checked
                },
              }}
            />
          }
          label={<Typography sx={{ ...fonts }}>Verified</Typography>}
        />
        <FormControl fullWidth variant="outlined" margin="dense">
          <InputLabel sx={{ ...fonts }}>Verified by ID Status</InputLabel>
          <Select
            name="isVerifiedbyID"
            value={editFormData.isVerifiedbyID}
            onChange={handleEditFormChange}
            label="Verified by ID Status"
            sx={{ ...selectStyles }}
          >
            <MenuItem value="not_submitted" sx={{ ...fonts }}>
              Not Submitted
            </MenuItem>
            <MenuItem value="pending" sx={{ ...fonts }}>
              Pending
            </MenuItem>
            <MenuItem value="approved" sx={{ ...fonts }}>
              Approved
            </MenuItem>
            <MenuItem value="rejected" sx={{ ...fonts }}>
              Rejected
            </MenuItem>
          </Select>
        </FormControl>
        <FormControl fullWidth variant="outlined" margin="dense">
          <InputLabel sx={{ ...fonts }}>Role</InputLabel>
          <Select
            name="role"
            value={editFormData.role}
            onChange={handleEditFormChange}
            label="Role"
            sx={{ ...selectStyles }}
          >
            <MenuItem value="user" sx={{ ...fonts }}>
              User
            </MenuItem>
            <MenuItem value="superAdmin" sx={{ ...fonts }}>
              Super Admin
            </MenuItem>
          </Select>
        </FormControl>
      </DialogContent>
      <DialogActions sx={{ mt: 1, mb: 1 }}>
        <Button
          size="small"
          variant="contained"
          sx={{ ...secondaryButtonStyles }}
          onClick={onClose}
        >
          Cancel
        </Button>
        <Button
          size="small"
          variant="contained"
          sx={{ ...primaryButtonStyles }}
          onClick={handleSaveEdit}
          disabled={isSubmitting}
        >
          {isSubmitting ? (
            <>
              <span>Saving...</span>
              <CircularProgress size={20} sx={{ color: "white" }} />
            </>
          ) : (
            "Save"
          )}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
